var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOfficialYoutube(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.2686 5.47632C33.8661 3.32072 32.6801 1.62303 31.1743 1.0469C28.4448 0 17.5 0 17.5 0C17.5 0 6.55525 0 3.82573 1.0469C2.31988 1.62313 1.13389 3.32072 0.731359 5.47632C0 9.38346 0 17.5354 0 17.5354C0 17.5354 0 25.6873 0.731359 29.5944C1.13389 31.75 2.31988 33.377 3.82573 33.9531C6.55525 35 17.5 35 17.5 35C17.5 35 28.4447 35 31.1743 33.9531C32.6801 33.377 33.8661 31.75 34.2686 29.5944C35 25.6873 35 17.5354 35 17.5354C35 17.5354 35 9.38346 34.2686 5.47632ZM13.9204 24.9367V10.134L23.0681 17.5355L13.9204 24.9367Z",
    fill: "#AAAAAA"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOfficialYoutube);
export default __webpack_public_path__ + "static/media/officialYoutube.3a28df96.svg";
export { ForwardRef as ReactComponent };